'use client'

import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { DURATION_NORMAL, EASE_OUT, useReducedMotion, reduceMotion } from '@/lib/motion'
import { MainNavigation } from './sidebar/MainNavigation'
import { ToggleButton } from './sidebar/ToggleButton'
import { UserProfileButton } from './sidebar/UserProfileButton'

export interface SidebarProps {
  className?: string
  expanded?: boolean
  onToggle?: () => void
}

export function Sidebar({
  className,
  expanded = false,
  onToggle,
}: SidebarProps) {
  const prefersReduced = useReducedMotion()

  return (
    <motion.aside
      animate={{ width: expanded ? 240 : 64 }}
      transition={reduceMotion(prefersReduced, { duration: DURATION_NORMAL, ease: EASE_OUT })}
      className={cn(
        'relative flex flex-col justify-between',
        'h-full',
        'px-(--sidebar-padding-x) py-(--sidebar-padding-y)',
        ' border-(--sidebar-divider-color)',
        className
      )}
    >
      {/* Toggle Button */}
      {onToggle && <ToggleButton expanded={expanded} onClick={onToggle} />}

      {/* Top Section */}
      <MainNavigation expanded={expanded} />

      {/* Bottom Section */}
      <div
        className={cn(
          'flex flex-col gap-(--sidebar-gap)',
          'items-stretch'
        )}
      >
        <UserProfileButton expanded={expanded} />
      </div>
    </motion.aside>
  )
}
